import {Routes} from "@angular/router";
import {Constants} from "./modules/constants";
import {KrEnrollAuthComponent} from "./modules/enroll/personal-authentication/kr-enroll-auth/kr-enroll-auth.component";

// Minimal routes for the standalone direct route bootstrap.
// Base href is "/" (see index.html), so these must include the ux/cart prefix
// the merged app serves everything under — otherwise the popup loads at
// /ux/cart/direct/krAuth and matches nothing, rendering a blank page.
export const directRoutes: Routes = [
    {
        path: Constants.URL_BASE_CART,
        children: [
            { path: 'direct/' + Constants.ENROLL_KRAUTH_STATE, component: KrEnrollAuthComponent },
            { path: ':locale/direct/' + Constants.ENROLL_KRAUTH_STATE, component: KrEnrollAuthComponent },
        ],
    },
];

